export interface WebhooksState {
    webhooks: any[] | undefined;
    selectedWebhook: any | undefined;
    loading: boolean;
    detailLoading: boolean;
}

export const initialWebhooksState: WebhooksState = {
    webhooks: undefined,
    selectedWebhook: undefined,
    loading: false,
    detailLoading: false,
};
